"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.markAllAsRead = exports.markAsRead = exports.getNotifications = exports.loadMore = exports.resetState = exports.updateItem = exports.updateList = exports.setList = exports.setAllLoaded = void 0;
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const preloaderSlice_1 = require("./preloaderSlice");
const initialState = {
    items: [],
    allLoaded: false,
    limit: 10
};
const notificationCenter = toolkit_1.createSlice({
    name: 'notificationCenter',
    initialState: initialState,
    reducers: {
        setAllLoaded: (state) => {
            state.allLoaded = true;
            return state;
        },
        setList: (state, action) => {
            state.items = action.payload;
            return state;
        },
        updateList: (state, action) => {
            state.items = uniqBy_1.default([
                ...state.items,
                ...action.payload
            ], 'id');
            return state;
        },
        updateItem: (state, action) => {
            const index = state.items.findIndex(i => i.id === action.payload.id);
            state.items[index] = action.payload;
            return state;
        },
        resetState: (state) => {
            return initialState;
        }
    }
});
_a = notificationCenter.actions, exports.setAllLoaded = _a.setAllLoaded, exports.setList = _a.setList, exports.updateList = _a.updateList, exports.updateItem = _a.updateItem, exports.resetState = _a.resetState;
const loadMore = data => async (dispatch) => {
    try {
        const { offset } = data;
        const items = await api_1.NotificationCenter.getNotifications({ offset });
        if (!items.length) {
            return dispatch(exports.setAllLoaded());
        }
        dispatch(exports.updateList(items));
    }
    catch (e) {
        dispatch(exports.setAllLoaded());
    }
};
exports.loadMore = loadMore;
const getNotifications = () => async (dispatch) => {
    try {
        dispatch(preloaderSlice_1.showLoader());
        const items = await api_1.NotificationCenter.getNotifications();
        dispatch(exports.setList(items));
        dispatch(preloaderSlice_1.hideLoader());
    }
    catch (e) {
        dispatch(preloaderSlice_1.hideLoader());
    }
};
exports.getNotifications = getNotifications;
const markAsRead = (id) => async (dispatch) => {
    try {
        const item = await api_1.NotificationCenter.markAsRead(id);
        dispatch(exports.updateItem(item));
    }
    catch (e) {
        return false;
    }
};
exports.markAsRead = markAsRead;
const markAllAsRead = () => async (dispatch) => {
    try {
        await api_1.NotificationCenter.markAllAsRead();
    }
    catch (e) {
        return false;
    }
};
exports.markAllAsRead = markAllAsRead;
exports.default = notificationCenter.reducer;
